import React, { useContext } from 'react';

import Link from 'ati-ui-react/components/Link';
import styles from './styles.modules.scss';
import i18nStrings from './strings';
import { useLocalized } from 'utils/useLocalized';
import { LocaleContext } from 'contexts';
import {helpSiteUrl} from 'urls';

const Instruction = () => {
    const strings = useLocalized(i18nStrings);
    const locale = useContext(LocaleContext);
    const helpUrl = locale === 'en' ? `${helpSiteUrl}/active-carriers-search` : `${helpSiteUrl}/poisk-aktivnykh-perevozchikov`;

    return (
        <div className={styles['instruction']}>
            <div className={styles['how-to']}>
                {strings.howTo}
            </div>
            <div className={styles['links']}>
                <span className={styles['icon']}>
                    <svg
                        fill="none"
                        height="24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            clipRule="evenodd"
                            d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
                            fill="#8C969D"
                            fillRule="evenodd"
                        />
                    </svg>
                </span>
                <Link
                    gray
                    small
                    href={helpUrl}
                    target="_blank"
                    type="underline"
                >
                    {strings.help}
                </Link>
            </div>
        </div>
    );
};

export default Instruction;
